import { AIAvatar } from './Avatar';

export function AIAnimatedIllustration() {
	return <AIAvatar size="illustration" speed="slow" iconSpeed="none" />;
}
